<template>
    <form class="styledForm">
        <div class="form">
            <div class="ssm-main-infos">
                <div class="split">
                    <input class="styledInput" type="text" v-model="user.lastName" placeholder="Lastname *" name="lastname" required>
                    <input class="styledInput" type="text" v-model="user.firstName" placeholder="Firstname *" name="firstname" required>
                </div>
                <div class="split">
                    <input class="styledInput" type="text" v-model="user.email" placeholder="Email" name="email *" required>
                    <input class="styledInput" type="password" v-model="user.password" placeholder="Password" name="password">

                    <label>Admin</label>
                    <input type="radio" v-model="user.role" name="role" value="admin">

                    <label>User</label>
                    <input type="radio" v-model="user.role" name="role" value="user">
                </div>

            </div>

            <div class="ssm-bottom-form">
                <!-- user.id.length -->
                <button v-show="user._id === ''" class="green-btn" :disabled="!isFormValid()" @click="create()">Create User</button>
                <button v-show="user._id !== ''" class="green-btn" :disabled="!isFormValid()" @click="update()">Update User</button>
            </div>
        </div>
    </form>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "AdminUserNew",
        created() {
            if (this.$route.query.id){
                this.getUser(this.$route.query.id).then(data => {
                    this.user = data.data
                    this.user.password = ''
                })
            }
        },
        data(){
            return {
                user: {
                    _id: '',
                    lastName: '',
                    firstName: '',
                    email: '',
                    password: '',
                    role: 'user'
                }

            }
        },
        methods: {
            ...mapActions('user', ['getUser']),
            isFormValid(){

            }
        },
        computed:{

        }
    }
</script>

<style scoped lang="scss">

</style>
